var route = {
  path : '/OAuth/sensetime',
  getComponent(nextState, cb) {
      require.ensure([], (require) => {
          cb(null, require('../pc/components/ThirdPartyOAuth/OAuth.jsx').default)
      }, 'OAuth-ThirdParty')
  }
}


export default route;



// WEBPACK FOOTER //
// ./src/routes/OAuthSenseTime.js